export class NotificationDetails {
  notificationText:string = '';
}

export class NotificationModel {
  flatData: NotificationDetails = new NotificationDetails();
}